import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useAppContext } from './AppContext';

const Profile = ({ userName, userId }) => {
  const [name, setName] = useState(userName);
  const [password, setPassword] = useState('');
  const { t } = useAppContext();

  const handleSave = () => {
    // Add logic to save updated user information
  };

  return (
    <Box padding="16px">
      <Typography variant="h5" gutterBottom>
        {t("Edit Profile")}
      </Typography>
      <TextField
        label={t("Name")}
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label={t("Password")}
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button variant="contained" color="primary" onClick={handleSave}>
        {t("Save")}
      </Button>
    </Box>
  );
};

export default Profile;
